import { apiService } from './api';
import { StockLevel, StockMovement, StockAdjustment, PaginationParams } from '../types';

export interface AdjustStockRequest {
  productId: number;
  warehouseId: number;
  newQuantity: number;
  reason: string;
  notes?: string;
}

const STOCK_API = '/stock';

export const stockService = {
  // Stock Levels
  getStockLevels: (params?: PaginationParams) =>
    apiService.get<StockLevel[]>(`${STOCK_API}/levels`, {
      pageNumber: params?.pageNumber || 1,
      pageSize: params?.pageSize || 50,
    }),

  getStockLevelById: (id: number) =>
    apiService.get<StockLevel>(`${STOCK_API}/levels/${id}`),

  getStockLevelByProductAndWarehouse: (productId: number, warehouseId: number) =>
    apiService.get<StockLevel>(`${STOCK_API}/levels/product/${productId}/warehouse/${warehouseId}`),

  // Stock Movements
  getStockMovements: (params?: PaginationParams) =>
    apiService.get<StockMovement[]>(`${STOCK_API}/movements`, {
      pageNumber: params?.pageNumber || 1,
      pageSize: params?.pageSize || 50,
    }),

  getStockMovementsByProduct: (productId: number, params?: PaginationParams) =>
    apiService.get<StockMovement[]>(`${STOCK_API}/movements/product/${productId}`, {
      pageNumber: params?.pageNumber || 1,
      pageSize: params?.pageSize || 50,
    }),

  getStockMovementsByWarehouse: (warehouseId: number, params?: PaginationParams) =>
    apiService.get<StockMovement[]>(`${STOCK_API}/movements/warehouse/${warehouseId}`, {
      pageNumber: params?.pageNumber || 1,
      pageSize: params?.pageSize || 50,
    }),

  // Stock Adjustments
  adjustStock: (data: AdjustStockRequest) =>
    apiService.post<StockAdjustment>(`${STOCK_API}/adjust`, data),

  getStockAdjustments: (params?: PaginationParams) =>
    apiService.get<StockAdjustment[]>(`${STOCK_API}/adjustments`, {
      pageNumber: params?.pageNumber || 1,
      pageSize: params?.pageSize || 50,
    }),

  // Reports
  getLowStockReport: (reorderLevelThreshold?: number) =>
    apiService.get<StockLevel[]>(`${STOCK_API}/low-stock`, {
      threshold: reorderLevelThreshold,
    }),

  getStockReport: (warehouseId?: number, params?: PaginationParams) =>
    apiService.get<StockLevel[]>(`${STOCK_API}/reports/stock-report`, {
      warehouseId,
      pageNumber: params?.pageNumber || 1,
      pageSize: params?.pageSize || 50,
    }),
};
